import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { getAllUsersDetail, logoutAction } from "../../redux/actions/APIs";
import { Sidebar } from "../base";
import NewTopbar from "../base/NewTopbar";
import { useEffect } from "react";
import { clearApiResponse, defaultChild, getLoggedInUser, isLoading, resetResponse, selectedUser, selectOptionData, selectType } from "../../redux/actions";
import SidebarNew from "../base/SidebarNew";
import ImportFile from "./ImportFile";
import { PATHS, TOAST_TIMER } from "../../utils";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { datesorting, getChildData, getUserDetails } from "../../utils/helper";
import Success from "../notifications/Success";
import { toast } from "react-toastify";
import Error from "../notifications/Error";
import AddReward from "../setting/AddReward";
import LockPopup from "../controls/LockPopup";
import RewardUnlockPopup from "../widget/RewardUnlockPopup";
import RewardPopUp from "../base/RewardPopUp";

const MainLayOut = ({ children }) => {
	const params = useParams();
	const dispatch = useDispatch();
	const history = useHistory();
	
	const {
		alluserdetails,
		isAuth,
		error,
		loggedInUser,
		getSelectedUser,
		defaultChildData,
		response,
		selectOptData,
		signinresponse,
		signupresponse
	} = useSelector((state) => state.collections);
	//	console.log("MainLayOut : ", loggedInUser);

	useEffect(() => {
		dispatch(getAllUsersDetail());
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [defaultChildData])

	useEffect(()=>{
		dispatch(clearApiResponse());
	}, [history])

	useEffect(() => {
		if (error) {
			if (error === "Request failed with status code 403") {
				localStorage.removeItem("access_token");
				window.location.assign(PATHS.LANDINGPAGE);
				dispatch(logoutAction());
			} else if (error === "Unauthorized Access") {
				toast.error(<Error error={error} />, {
					position: "top-center",
					autoClose: TOAST_TIMER,
				});
				dispatch(resetResponse()).then(() => {
					dispatch(isLoading(false)).then(() => {
						// window.location.assign(PATHS.ACCESS_DENIED);
					});
				});
			} else {
				toast.error(<Error error={error} />, {
					position: "top-center",
					autoClose: TOAST_TIMER,
				});
				dispatch(resetResponse());
				dispatch(isLoading(false));
			}
		}
	}, [error]);

	useEffect(() => {
		if (alluserdetails && isAuth) {
			dispatch(getLoggedInUser(alluserdetails));	
		}
	}, [alluserdetails]);

	useEffect(() => {
		if (loggedInUser?.role?.name ===  "PARENT") {
			dispatch(defaultChild(datesorting(alluserdetails?.records[0]?.children)[0]));
		}else if (["LEARNER"]?.includes(loggedInUser?.role?.name)) {
			dispatch(defaultChild(loggedInUser));
		}else if (alluserdetails && params?.childId) {
			dispatch(defaultChild(getChildData(alluserdetails, params?.childId)));
		}
	}, [loggedInUser])

	useEffect(()=>{
			if(alluserdetails && params){
				dispatch(selectedUser(getUserDetails(alluserdetails, params)));
			}
		}, [alluserdetails])

	useEffect(() => {
		if (alluserdetails && (signupresponse?.success || signinresponse?.success)) {
			if (alluserdetails?.records[0]?.role?.name === "PARENT") {
				if (signupresponse?.success) {
                	dispatch(selectType("comleteUserSignUp"))
            	}
				// if(!localStorage.getItem("urlRedirection")){
				// 	history.push(PATHS.USER_PROFILE);
				// }
				
				dispatch(resetResponse());
				return;
			}
		}
	}, [alluserdetails, signinresponse, signupresponse])

	useEffect(() => {
		if (response && response?.success) {
			toast.info(<Success response={response} />, {});
			dispatch(resetResponse());
		}
	}, [response]);

	const [collaspe, setcollaspe] = useState(false)

	const handleclick = () => {
		setcollaspe(!collaspe)

	}

	return (
		<>
		<ImportFile />
			<div className={` ${collaspe ? 'notcollaspeSidebar' : 'not'}`}>
				{/* <Sidebar /> */}
				<SidebarNew
					handleeclick={handleclick}
					className="RootContent"
					collaspe={collaspe}
				/>

				<div className="main_content">
				{/* <AddReward></AddReward> */}
				 {/* <LockPopup /> */}
				 {/* <RewardUnlockPopup /> */}
				 {/* <RewardPopUp /> */}
					<NewTopbar className="RootContent" />
					<div className="Content_part flexsix w-100 maincontentpart RootContent">
						{children && children}
					</div>{" "}
				</div>{" "}

			</div>
			
		</>
	);
};
export default MainLayOut;